import { Locale, getLocale } from '@uikit/ui-kit';

export function getLocaleName(code: string): string {
  const locale: Locale | undefined = getLocale(code);
  return locale ? locale.name : code;
}
